import { render, staticRenderFns } from "./nfAlert.vue?vue&type=template&id=2ccd0f79&scoped=true&"
import script from "./nfAlert.vue?vue&type=script&lang=js&"
export * from "./nfAlert.vue?vue&type=script&lang=js&"
import style0 from "./nfAlert.vue?vue&type=style&index=0&id=2ccd0f79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd0f79",
  null
  
)

export default component.exports